var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 0.333344C7.88422 0.333344 8.73206 0.684533 9.35719 1.30965C9.98231 1.93478 10.3335 2.78262 10.3335 3.66668C10.3335 4.55073 9.98231 5.39858 9.35719 6.0237C8.73206 6.64882 7.88422 7.00001 7.00016 7.00001C6.11611 7.00001 5.26826 6.64882 4.64314 6.0237C4.01802 5.39858 3.66683 4.55073 3.66683 3.66668C3.66683 2.78262 4.01802 1.93478 4.64314 1.30965C5.26826 0.684533 6.11611 0.333344 7.00016 0.333344ZM7.00016 8.66668C10.6835 8.66668 13.6668 10.1583 13.6668 12V13.6667H0.333496V12C0.333496 10.1583 3.31683 8.66668 7.00016 8.66668Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.d05b25828c0ef57f735e4e4d6442d6ce.svg";
export { ForwardRef as ReactComponent };